/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>azure-ad-auth-reply.component.ts</name>
///
/// <description>
/// A component that is called when azure active directory replies with authentication information
/// Azure AD blog: http://www.cloudidentity.com/
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>12 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 12Aug16 YH  1.0.0000         First cut
/// 16Feb17 YH                   Bug 122471 - [AM]After account deactivate , it is allowing to login with that account id
/// 31Mar17 YH                   Bug 125722 - Show user better error message if Identity Provider is offline
/// 15May17 YH                   Bug 129494 - Hydrogen portal is stuck in the “Authernticating…” screen
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import {Component, ElementRef, Renderer} from '@angular/core';
import { Http, Response, Headers,RequestOptions } from '@angular/http';
import {ActivatedRoute,Params} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { HydrogenAppConfigService } from '../../../host.config.service';
import {HydUser} from '../../../models/user';
import {hydUtilService} from "../../../utils/hydUtils.service";
import {CUIFeatureInterface} from  '../../../interfaces/cui-feature.interface';
import { UserAPIService } from '../../../services/Crestron.HydrogenAPI.UserApi.service';
import {LogService} from '../../../services/log.service';
import { AccountApiService, AccountDetail, Feature} from '../../../services/Crestron.HydrogenAPI.AccountApi.service';
import {TranslatedStringsService } from '../../../services/language.service';
import * as moment from 'moment';
import {PermissionsService} from '../../../authorization/permissions/permissions.service';


@Component({
    templateUrl: './azure-ad-auth-reply.component.html'
})
export class AzureADAuthReplyComponent implements CUIFeatureInterface {

    private _authState: AuthState = AuthState.unknown;
    private config: any;
    private lblAuthenticating: string;
    private lblaccountUndeterminedHeader: string;
    private lblaccountUndeterminedMessage: string;
    private lblAccountPermissionsError: string;
    private lblProductTitle: string;

    private accountUndetermined: boolean;
    private lblAccountCheck: string;
    private userGivenName: string;
    private userLastName: string;
    //YH 3/31/2017 Bug 125722
    private jsonParseReviver: (key: string, value: any) => any = undefined;
    private lblUserAccessError: string;
    private lblWelcome: string;
    private lblAuthenticationError: string;
    private account: AccountDetail;

    constructor(private _http: Http,
        private _activatedRoute: ActivatedRoute,
        private _hydUser: HydUser,
        private _apiUserService: UserAPIService,
        private _log: LogService,
        private configSvc: HydrogenAppConfigService,
        private accountApiService: AccountApiService,
        private i18n: TranslatedStringsService,
        private elementRef: ElementRef,
        private renderer: Renderer,
        private permissionsService: PermissionsService
    ) {
    }

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------
    ngOnChanges(changes: any) { };
    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };
    ngAfterViewInit() { };
    ngAfterViewChecked() { };
    ngOnDestroy() { };

    public ngOnInit() {

        this.translate();

        if (document.getElementById("menu-resize-btn")) document.getElementById("menu-resize-btn").style.visibility = "hidden";
       
        this.config = this.configSvc.config;
        console.debug(hydUtilService.TimeStamp() + "Reply from Azure AD");
        this._authState = AuthState.authenticating;

        //window.location should be something like http://localhost:3000/#code=AQABAAAAAADRNYRQ3dhRSrm-4K-adpCJWcNpvsklnvsyj3lâ€¦sfBpOhg0hj2nJxDkIWd9H4u&session_state=00103939-b21b-4f14-b123-7eb858395c3e

        let state$: Observable<string> = this._activatedRoute.queryParams.map(params => params['state'] || null);
        state$.subscribe(state => {
            this._log.logMessage("auth hydAzureADAuthReplyComponent.ngOnInit() request state=" + this._hydUser.authenticationCodeState + " reply state=" + state);
            //YH 5/19/2017 Bug 129494 - Hydrogen portal is stuck in the Authenticating screen
            //Remove the state check for now until a solution to this._hydUser.authenticationCodeState can be found
            //if (state===this._hydUser.authenticationCodeState) {
            let code$: Observable<string> = this._activatedRoute.queryParams.map(params => params['code'] || null);
            code$.subscribe(code => this.GetAccessTokenFromAuthorizationService(code));
            //}
            //YH 5/16/2017 Bug 129494
            //else
            //{
            //    this._authState = AuthState.unknown;
            //    this.lblAuthenticationError = this.i18n.translate("user-login-authentication-error-reopen-browser");
            //}
        });

        this.accountUndetermined = false;


        let container = this.elementRef.nativeElement.parentElement.parentElement;
        if (container) {
            this.renderer.setElementStyle(container, 'background-color', '#343A3E');

        }


    }

    private translate() {
        this.lblAuthenticationError = this.i18n.translate("user-login-authentication-error");
        this.lblAuthenticating = this.i18n.translate("authenticating");
        this.lblProductTitle = this.i18n.translate("product-title");
    }

    private SetUserInfo(id_token: string, accessToken: string, refreshToken: string) {
        if (id_token) {
            //console.debug(hydUtilService.TimeStamp() + "id_token:"+id_token);
            var idTokenPayload = this.parseJwt(id_token);
            //YH 3/31/2017 Bug 125722
            this.lblWelcome = this.i18n.translate("welcome");

            this.userGivenName = idTokenPayload.given_name;
            this.userLastName = idTokenPayload.family_name;
            //console.debug("token payload:");
            //console.debug(idTokenPayload);

            //YH 1/31/2017 Bug 118131 - Implement authorization refresh when access token expires
            var accessTokenPayload = this.parseJwt(accessToken);

            //YH12/12/2016 Get user's account from the user API
            this._hydUser.SetAccessToken("bearer " + accessToken);

            let userId: string;
            if (idTokenPayload.upn) {
                userId = idTokenPayload.upn
                idTokenPayload.unique_name = userId;
            }
            else if (idTokenPayload.email) {
                userId = idTokenPayload.email;
                idTokenPayload.unique_name = userId;
            }
            else {
                userId = idTokenPayload.unique_name;
            }

            if (idTokenPayload.roles != null || this.configSvc.config.UseB2C) {
                this._apiUserService.getUserById(userId).subscribe(
                    user => {
                        this.checkAccountActive(user.accountId).then(
                            resolve => {
                                let tier = this.account.tier;
                                if (this.account.createdOn != null) {
                                    let createdDatePlus90 = new Date(this.account.createdOn.setDate(this.account.createdOn.getDate() + 90));
                                    tier = createdDatePlus90 < new Date() ? this.account.tier : "Premium";
                                }
                                this.checkAccountPermissions(tier, user.role, user.accountId).then(
                                    resolve => {
                                        this._apiUserService.updateNewFeatureFlag(userId).subscribe(
                                            response => {

                                                this._log.logMessage("AzureADAuthReplyComponent.SetUserInfo() userId=" + userId + " is a member of account " + user.accountId);
                                                this._hydUser.OnUserAuthenticated(
                                                    idTokenPayload.given_name,
                                                    idTokenPayload.family_name,
                                                    idTokenPayload.roles,
                                                    idTokenPayload.unique_name,
                                                    idTokenPayload.email,
                                                    //YH 1/31/2017 Bug 118131 - Implement authorization refresh when access token expires
                                                    accessTokenPayload.exp,
                                                    refreshToken,
                                                    user.accountId,
                                                    this.account.accountNumber,
                                                    tier,
                                                    this.account.numberAllotted,
                                                    this.account.expirationDateString,
                                                    this.account.deviceCount,
                                                    this.account.isAlertsEnabled
                                                );
                                                this._authState = AuthState.authenticated;
                                                this._hydUser.OnUserAuthorized();
                                                //this._apiUserService.updateNewFeatureFlag(userId);
                                                //Naresh Sanchi - 143337 - In manager portal, last Login details shows the wrong time always. It does not get updated.
                                                this._apiUserService.updateUserStatus(userId, true).subscribe();
                                                this.accountUndetermined = false;
                                            });
                                    },
                                    reject => {

                                    }
                                );

                            },
                            reject => {
                                this.accountUndetermined = true;
                            }
                        );
                    },
                    error => {
                        this._log.logMessage("hydAzureADAuthReplyComponent SetUserInfo failed retrieving user's accountId");
                    }
                );
            } else {
                //DA 4/12/2017 Bug 127378
                this._log.logMessage("hydAzureADAuthReplyComponent SetUserInfo user roles is null");
                this._authState = AuthState.denied;
            }
        }
        else {
            this._authState = AuthState.denied;
        }
    }

    private GetAccessTokenFromAuthorizationService(code: string) {
        //console.debug(hydUtilService.TimeStamp() + "Getting access token");
        //console.debug("Access code:"+code);
        this._authState = AuthState.authorizing;
        var authority = this.config.azureAD.SecureTokenServer + this.config.azureAD.Tenant + this.config.azureAD.OAuth2Token;
        var redirectUrl = encodeURIComponent(this.GetRedirectUrl());
        var url;
        if(!this.configSvc.config.UseB2C) {
            var authority = this.config.azureAD.SecureTokenServer + this.config.azureAD.Tenant + this.config.azureAD.OAuth2Token;
             url = this.config.serviceUrl["authz"] + "/api/authorization" +
                "?authority=" + encodeURIComponent(authority) +
                "&authorizationCode=" + code +
                "&userId=" + encodeURIComponent(this._hydUser.UserId) +
                "&resource=" + this.config.azureAD.AADHydrogenAuthorizationServiceId +
                "&redirectUri=" + redirectUrl;
        } else {
            var authority = this.config.azureB2C.SecureTokenServer + this.config.azureB2C.Tenant + this.config.azureB2C.OAuth2Token;
            url = this.config.serviceUrl["authz"] + "/api/authorization" +
               "?authority=" + encodeURIComponent(authority) +
               "&authorizationCode=" + code +
               "&userId=" + encodeURIComponent(this._hydUser.UserId) +
               "&resource=" + this.config.azureB2C.AADHydrogenAuthorizationServiceId +
               "&redirectUri=" + redirectUrl;
        }
        //YH 1/19/2017 Fix for Firefox. Spell out to pesky FF that it should accept a json
        let headers = new Headers({ 'Accept': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        this._http.get(url, options)
            .map((res: Response) => res.json())
            .subscribe(
            dataJosn => {
                console.debug("hydAzureADAuthReplyComponent.GetAccessTokenFromAuthorizationService() auth=" + dataJosn);
                //console.debug(hydUtilService.TimeStamp() + "Got access token");
                var data = JSON.parse(dataJosn);
                this.OnAuthorizationSuccess(data);
            },
            err => {
                this.OnAuthorizationFailure(err);
            },
            () => {//console.log('GetAccessTokenFromAuthorizationService done')
            }
            );
    }

    private OnAuthorizationSuccess(data) {
        //data.AccessToken,data.RefreshToken,data.ErrorCode,data.ErrorMsg

        if (data.AccessToken)
            this._authState = AuthState.authorized;
        else
            this._authState = AuthState.unauthorized;

        if (this._authState == AuthState.authorized) {
            this.SetUserInfo(data.IdToken, data.AccessToken, data.RefreshToken);
            //YH 12/12/2016 Move after we get the user's account
            //this._hydUser.OnUserAuthorized();
        }
        else
            this._hydUser.OnUserNotAuthorized(data.ErrorCode, data.ErrorCode);
    }

    private OnAuthorizationFailure(err) {
        this._authState = AuthState.unauthorized;
        //console.error("hydAzureADAuthReplyComponent.OnAuthorizationFailure");
        //console.error(err);
        //YH 3/31/2017 Bug 125722
        this.lblUserAccessError = this.i18n.translate("user-login-access-error-header");

        const responseText = err.text();
        const status = err.status;
        if (status === 409) {
            let resultData409 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData409) {
                if (resultData409.Message) {
                    let errorCode: string = resultData409.Message;
                    let errorMessage: string = this.i18n.translate("user-login-access-error-code") + errorCode;
                    this._hydUser.OnUserNotAuthorized(errorCode, errorMessage);
                }
            }
        }

    }

    private parseJwt(token: string) {
        if (token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(window.atob(base64));
        }
        return null;
    };

    private GetRedirectUrl() {
        return window.location.protocol + "//" + window.location.host + this.config.azureAD.LoginReplyPath;
    }

    private get AuthenticatingUser(): boolean {
        return this._authState == AuthState.authenticating || this._authState == AuthState.authorizing || (this._authState == AuthState.authorized && !this.accountUndetermined);
    }

    //DA 4/12/2017 Bug 127378
    private get showWelcomeUser(): boolean {
        return this._authState == AuthState.authorized;
    }

    private get AccountPermissionsError(): boolean {
        return (!this.account || !this.account.tier);
    }

    private get UserAuthenticationFailed(): boolean {
        return this._authState == AuthState.unknown || this._authState == AuthState.denied;
    }

    private get UserNotAuthorized(): boolean {
        return this._authState == AuthState.unauthorized;
    }


    private checkAccountActive(accountId: string): Promise<void> {
        let inst = this;
        this.lblAccountCheck = this.i18n.translate("user-login-account-check");

        return new Promise<void>(function (resolve, reject) {
            let obs = inst.accountApiService.getAccountById(accountId).subscribe(
                account => {
                    obs.unsubscribe();
                    inst.account = account;

                    if (!account.isExpired && account.isActive && !account.isDeleted)
                        resolve();
                    else {
                        inst.lblaccountUndeterminedHeader = inst.i18n.translate("user-login-account-inactive-header");
                        inst.lblaccountUndeterminedMessage = inst.i18n.translate("user-login-account-inactive-message");
                        reject();
                    }
                },
                error => {
                    obs.unsubscribe();
                    inst.lblaccountUndeterminedHeader = inst.i18n.translate("user-login-account-undetermined-header");
                    inst.lblaccountUndeterminedMessage = inst.i18n.translate("user-login-account-undetermined-message");
                    reject("user-login-account-notfound");
                }
            );
        });
    }

    private checkAccountPermissions(tier: string, roleId: string, accountId: string): Promise<void> {
        let inst = this;
        return new Promise<void>(function (resolve, reject) {
            let val = 1;
            let obs = inst.accountApiService.getFeatures(tier, roleId, accountId).subscribe(
                features => {

                    sessionStorage.setItem("tier", JSON.stringify(tier));
                    sessionStorage.setItem("permissions", JSON.stringify(features));

                    obs.unsubscribe();
                    inst.permissionsService.tier = tier;
                    if (features && features.length > 0) {
                        features.forEach(function (item) {
                            inst.permissionsService.addPermission(JSON.parse(JSON.stringify(item)));
                        });
                        resolve();
                    }
                    else {
                        inst.lblAccountPermissionsError = inst.i18n.translate("account-permissions-error");
                        reject();
                    }
                },
                error => {
                    obs.unsubscribe();
                    inst.lblAccountPermissionsError = this.i18n.translate("account-permissions-error");
                    reject();
                }

            );

        });


    }

}

enum AuthState {
    unknown, denied, authenticating, authenticated, authorizing, unauthorized, authorized
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authentication/azure-active-directory/azure-ad-auth-reply/azure-ad-auth-reply.component.ts